import React from 'react';
import { MessageSquareQuote, ShieldCheck, Terminal } from 'lucide-react';

const InputForm = ({
  question,
  setQuestion,
  constraints,
  setConstraints,
  testCase,
  setTestCase,
  onSubmit
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-6">
      {/* Coding Question */}
      <div>
        <label className="flex items-center gap-2 text-sm font-semibold text-gray-800 mb-1">
          <MessageSquareQuote size={18} className="text-blue-500" />
          Coding Question
        </label>
        <textarea
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="e.g., Find the largest subarray sum"
          className="w-full rounded-xl border border-gray-300 p-3 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none shadow-sm transition-all"
          rows={4}
          required
        />
      </div>

      {/* Constraints */}
      <div>
        <label className="flex items-center gap-2 text-sm font-semibold text-gray-800 mb-1">
          <ShieldCheck size={18} className="text-purple-500" />
          Constraints
        </label>
        <textarea
          value={constraints}
          onChange={(e) => setConstraints(e.target.value)}
          placeholder="e.g., 1 ≤ N ≤ 10^5"
          className="w-full rounded-xl border border-gray-300 p-3 text-gray-900 focus:ring-2 focus:ring-purple-500 focus:outline-none resize-none shadow-sm transition-all"
          rows={3}
        />
      </div>

      {/* Test Case */}
      <div>
        <label className="flex items-center gap-2 text-sm font-semibold text-gray-800 mb-1">
          <Terminal size={18} className="text-indigo-500" />
          Sample Test Case
        </label>
        <textarea
          value={testCase}
          onChange={(e) => setTestCase(e.target.value)}
          placeholder={`e.g.,\nInput: [1, -2, 3, 4, -1]\nOutput: 7`}
          className="w-full rounded-xl border border-gray-300 p-3 text-gray-900 focus:ring-2 focus:ring-indigo-500 focus:outline-none resize-none shadow-sm transition-all"
          rows={3}
        />
      </div>
    </form>
  );
};

export default InputForm;
